export default "__VITE_ASSET__BTbEnnOB__"